import React, { useEffect, useState, useContext, ReactElement } from 'react';
import Layout from '../../components/shared/Layout';
import { GenericTableHeader } from '../../components/shared/GenericTable';
import NewCSV from '../../components/newCSV/NewCSV';
import axios from 'axios';
import routes from '../../constants/routes';
import { jsonToCSV } from 'react-papaparse';
import { useNavigate, useLocation, useOutletContext, useLoaderData } from 'react-router-dom';
import { CallSession, LocationState } from '../../components/shared/CallSession';
import getSequencesStepsFromOutreachAsync from '../../api/Sync/getSequenceStepsFromOutreachAsync';
import { UITabbedContainer, Tab } from '../../core/ui/UITabbedContainer';
import UICard from '../../core/ui/UICard';
import GenericList from '../../components/shared/GenericList';
import { UIButton } from '../../core/ui/UIElements';
import { featuresStore } from '../../components/app/FeaturesProvider';
import { Sequence, SequenceStep } from '../../types/OutreachTypes';
import styled from 'styled-components';
import UITable from '../../core/ui/UITable';
import tabTitle from '../../utils/updateTitle';
import getListsFromHubspotAsync from '../../api/Sync/getListsFromHubspotAsync';
import getHubspotAccountsAsync from '../../api/Sync/getHubspotAccountsAsync';
import getOutreachAccountsAsync from '../../api/Sync/getOutreachAccountsAsync';
import getFoldersSalesforceAsync from '../../api/Sync/getSalesforceFolderAsync';
import getReportsSalesforceAsync from '../../api/Sync/getSalesforceReportAsync';
import { HubspotContact, HubspotList } from '../../types/HubspotTypes';
import { SalesforceContact, SalesforceList } from '../../types/SalesforceTypes';
import getHubspotContactsAsync from '../../api/Sync/getHubspotContactsAsync';
import getSalesforceContactsAsync from '../../api/Sync/getSalesforceContactsAsync';
import deleteContactAsync from '../../api/Contacts/deleteContactAsync';
import SearchBar from '../../components/searchBar/searchBar';
import { StatusCodes } from 'http-status-codes';
import useTimeAgo from '../../Presentation/Common/hooks/useTimeAgo.hook';
import { motion } from 'framer-motion';
import ButtonOutlined from '../../Presentation/Common/Buttons/ButtonOutlined.button';
import {
  faArrowRotateRight,
  faDownload,
  faBug,
  faArrowLeft,
  faCheck,
  faExclamationTriangle,
  faPhone,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import animations from '../../core/ui/base/Animations';
import useCallSessionViewModel from 'tendril-v2/src/Presentation/Views/CallSession/callSession.viewmodel';
import useContactsViewModel from 'tendril-v2/src/Presentation/Views/Contacts/contacts.viewmodel';
import ContactsFilter from 'tendril-v2/src/Presentation/Views/Contacts/Components/ContactsFilter';
import { Input } from 'tendril-v2/src/Presentation/Common/Components/ui/input';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { rebuildContactsCSV } from 'tendril-v2/src/Domain/helpers/csvRebuilder.helper';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'tendril-v2/src/Presentation/Common/Components/ui/tooltip';
import { ContactsRepository } from 'tendril-v2/src/Data/Repository/contacts-nest/contacts/contactsRepository';
import { CSVContact } from 'tendril-v2/src/Data/DataSource/contacts-nest/contacts/entities/contact.entity';
import { validateContacts } from '../../core/utils/validations/validateContacts';
import UILoader from 'tendril-v2/src/Presentation/components/shared/UILoader';
import getSalesforceAccounts from 'tendril-v2/src/Data/DataSource/sync/salesforce/getSalesforceAccounts';
import { toast } from 'tendril-v2/src/Presentation/Common/Components/ui/use-toast';
import { ContactListByCallSession } from 'tendril-v2/src/Data/DataSource/contacts-nest/callSession/entities/callSession.entity';
import { useLogger } from '../../components/app/LoggerProvider';

const window = globalThis as any;

const headers: GenericTableHeader[] = [
  { text: 'Status', width: '1' },
  { text: 'Name', width: '2' },
  { text: 'Company', width: '2' },
  { text: 'Position', width: '2' },
  { text: 'Phone Number', width: '2' },
  { text: 'Notes', width: '1.5' },
];

const ContactsValidator = ({ errorMessages }) => {
  const hasErrors = Array.isArray(errorMessages) && errorMessages.length > 0;
  const messages = hasErrors ? errorMessages.map((msg) => `${msg}`).join('\n') : 'No errors';

  const invalidPhone = errorMessages.some((message: string) => message.includes('Invalid phone number format'));

  return (
    <div className="text-center">
      <style>
        {`
          .table-container {
            width: 100%;
          }
          
          .table-container:hover .error-message {
            display: block;
          }

          .error-message {
            display: none; 
            position: absolute;
            padding: 10px;
            border-radius: 4px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1000;
            font-size: 15px;
            font-weight: 400;
          }
        `}
      </style>
      <div className="table-container w-full">
        {hasErrors ? (
          invalidPhone ? (
            <FA icon={faPhone} className="text-app-error h-5 w-5 icon-hover" />
          ) : (
            <FA icon={faExclamationTriangle} className="text-app-warning h-5 w-5 icon-hover warning" />
          )
        ) : (
          <FA icon={faCheck} className="text-app-ok h-5 w-5 icon-hover" />
        )}
        <div
          className={`error-message ${
            hasErrors
              ? 'bg-app-error_background text-app-error border-1 border-app-error'
              : 'bg-app-ok_background text-app-ok border-1 border-app-ok'
          }`}
        >
          <b>{messages}</b>
        </div>
      </div>
    </div>
  );
};

const tableBodies = [
  {
    id: 'type-id',
    customRender: true,
    renderFunc: ContactsValidator,
  },
  `name`,
  `accountName`,
  `jobTitle`,
  `phone`,
  `notes`,
];

type SelectedItem = {
  id: string;
  title?: string;
  select?: boolean;
  type?: string;
  tendrilId: string;
  sequenceId: string;
};

interface ContactsListI {
  id: string;
  organizationId: string;
  title: string;
}

type OutreachProspectDto = {
  tendrilId: string;
  accountName: string;
  email: string;
  name: string;
  notes: string;
  phone: string;
  jobTitle: string;
  outreachProspectId: number;
  outreachSequenceId: string;
  outreachSequenceStep: string;
};

type SalesforceProspectDto = {
  tendrilId: string;
  accountName: string;
  email: string;
  name: string;
  notes: string;
  phone: string;
  jobTitle: string;
};

type OutreachProspectsResponse = {
  prospects: OutreachProspectDto[];
  createdAt: Date;
};

interface ContactInterface {
  accountName: string;
  contactListId: string;
  email: string;
  id: string;
  jobTitle: string;
  name: string;
  phone: string;
  crmId: string;
  notes: string;
  notesAgent: string;
  notesSDR: string;
  errorMessages: string[];
}

type ContactList = {
  id: string;
  contactListId: string;
  completed: boolean;
};

const TextContainer = styled.div`
  display: grid;
  place-items: center;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: 1rem;
  font-weight: 600;
  margin: auto;
`;

const StyledSpan = styled.span`
  margin-bottom: 1rem;
`;

const ContactsCounter = styled.div`
  width: 100%;
  height: 20px;
  color: ${({ theme }) => theme.colors.darkGray};
  text-align: right;
`;

const Contacts = (): JSX.Element => {
  const { userSession, handleRoutesLogout, intervals, setIntervals } = useOutletContext() as any;
  const { salesforce, outreach, hubspot, hubspotCustom, contactsFilter } = useContext(featuresStore).featuresState;
  const [callSession, setCallSession] = useState<CallSession>({} as CallSession);
  const location = useLocation();
  const [isSession, setIsSession] = useState(true);
  const [orgId, setOrgId] = useState<string | undefined>('');
  const [contactsList, setContactsList] = useState<ContactsListI[]>([]);
  const [visibleNewCSV, setVisibleNewCSV] = useState(false);
  const [visibleTable, setVisibleTable] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [contacts, setContacts] = useState<CSVContact[]>([]);
  const [optionSelected, setOptionSelected] = useState([] as any[]);
  const [selectedList, setSelectedList] = useState('');
  const [showReports, setShowReports] = useState(false);
  const [contactListName, setContactListName] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [newFile, setNewFile] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [search, setSearch] = useState<string>('');
  const [btnText, setBtnText] = useState('Upload');
  const [showButton, setShowButton] = useState(false);
  const [tableHeaders, setTableHeaders] = useState(headers);
  const [tableBody, setTableBody] = useState(tableBodies);
  const [showPopUpSalesforce, setShowPopUpSalesforce] = useState(false);
  const [salesforceJson, setJsonSalesforce] = useState({});

  const [loadingStatus, updateLoadingStatus] = useState<{
    sequences: boolean;
    contacts: boolean;
  }>({ sequences: true, contacts: false });
  const [label, setLabel] = useState<string | ReactElement>('Select a sequence to show');
  const [errorMessage, setError] = useState('');
  const [outreachSequenceSteps, dispatch] = useState([] as Sequence[]);
  const [hubspotSequences, setLists] = useState([] as HubspotList[]);
  const [salesforcesSequences, setListsSalesforce] = useState([] as SalesforceList[]);
  const navigate = useNavigate();
  const { logger } = useLogger();

  const setSequenceSteps = (sequences: any[]) => dispatch(sequences);

  const setHubspotLists = (sequences: any[]) => setLists(sequences);

  const contactsListLoader = useLoaderData() as any;

  const { timeAgo, updateTimeAgoDate } = useTimeAgo({
    timezone: userSession?.timezone,
  });
  const [showRefreshButton, setShowRefreshButton] = useState(false);
  const [currentSelectedElement, setCurrentSelectedElement] = useState<SelectedItem>();
  const { titlesSession, formatAndSetData } = useCallSessionViewModel();
  const { sessionIds, setSessionIds, fetchContactsBySdrId } = useContactsViewModel();
  const { getContactsByContactListId } = ContactsRepository();

  if (window.location.search === '?setup=1') {
    tabTitle('Tendril Connect | Contacts - setup');
  } else {
    tabTitle('Tendril Connect | Contacts');
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const state = location.state as LocationState;

    const setup = urlParams.get('setup');
    if (setup && setup === '1' && state) {
      setCallSession(state.callSession);
    } else {
      navigate('/contacts');
      setIsSession(false);
    }
  }, [callSession, location.state]);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        setOrgId(userSession.organizationId);

        const contactsListUrl = `${routes.get.contacts.contactListsNest}/${userSession.organizationId}`;

        const contactListId = await axios.get<ContactsListI[]>(contactsListUrl);

        setContactsList(contactListId.data);

        updateLoadingStatus((prevState) => ({
          ...prevState,
          sequences: false,
        }));
      } catch (error: unknown) {
        const statusCode = axios.isAxiosError(error) ? error.response?.status : StatusCodes.INTERNAL_SERVER_ERROR;

        switch (statusCode) {
          case StatusCodes.NOT_FOUND:
            toast({
              variant: 'default',
              title: 'No contacts list created',
              description: 'Please create your first contacts list.',
            });
            break;
          default:
            toast({
              variant: 'destructive',
              title: 'Failed',
              description: 'Could not get Contacts Lists',
            });
            break;
        }

        setVisibleNewCSV(true);
        updateLoadingStatus((prevState) => ({
          ...prevState,
          contacts: false,
          sequences: false,
        }));
      }
    };

    isMounted && fetchData();
    return () => {
      isMounted = false;
    };
  }, [userSession.userId]);

  useEffect(() => {
    const getContacts = async () => {
      if (optionSelected.length) {
        const found = optionSelected.some((el) => {
          if (el !== undefined) {
            if (el.id === 'newItem' && el.select === true) {
              return el;
            }
          }
        });
        if (found) {
          setVisibleTable(false);
          setVisibleNewCSV(true);
          setShowButton(true);
        } else {
          const selectionInfo = optionSelected
            .filter((item) => item !== undefined && item.select === true)
            .reduce(
              (result, item) => {
                result.ids.push(item.id);
                result.isFiltered = item.type === 'filteredContacts';
                return result;
              },
              { ids: [], isFiltered: false },
            );

          if (contactsFilter && selectionInfo.isFiltered) {
            setVisibleNewCSV(false);

            setDisabled(!disabled);

            setShowButton(!showButton);

            setSessionIds(selectionInfo.ids.slice(0, 5));

            console.log(selectionInfo);

            selectionInfo.ids.length &&
              (await fetchContactsBySdrId([...selectionInfo.ids]).then((contactsResponse: CSVContact[]) => {
                updateContactsViewStates(contactsResponse);
              }));
          } else {
            optionSelected.map(async (item) => {
              if (item !== undefined) {
                if (item.select === false) {
                  setVisibleNewCSV(false);
                  setVisibleTable(false);
                  setDisabled(true);
                  setShowButton(false);
                }

                if (item.select === true && item.id !== 'newItem') {
                  let contactsResponse: ContactInterface[] | OutreachProspectDto[] | SalesforceProspectDto[] = [];

                  if (item.tendrilId) {
                    if (item.type === 'OUTREACH') {
                      contactsResponse = await getAllOutreachContacts(item);
                    } else if (item.type === 'CUSTOM_HUBSPOT') {
                      contactsResponse = await getAllHubspotContacts(item, true);
                    } else if (item.type === 'SALESFORCE') {
                      if (showReports) {
                        contactsResponse = await getAllSalesforceContacts(item);
                      } else {
                        setFolderName(item.title);
                        const { lists, error } = await getReportsSalesforceAsync(
                          item.title,
                          item.orgId,
                          item.userId,
                          item.tendrilId,
                        );
                        setListsSalesforce(prepareSalesforceListsForList(lists));
                        setShowReports(true);
                      }
                    } else {
                      contactsResponse = await getAllHubspotContacts(item);
                    }
                  } else {
                    contactsResponse = await getAllContacts(item);
                  }
                  updateContactsViewStates(contactsResponse);
                }
              }
            });
          }
        }
      }
    };

    getContacts();
  }, [optionSelected]);

  useEffect(() => {
    const validateInput = () => {
      optionSelected.forEach((item) => {
        if (item !== undefined) {
          if (item.id !== 'newItem' && item.select === true) {
            setBtnText('Upload');
            setDisabled(false);
          }
          if (item.id === 'newItem' && item.select === true) {
            setBtnText('Save');
            if (contactListName.length > 0 && contacts.length > 0) {
              setDisabled(false);
            } else {
              setDisabled(true);
            }
          }
        }
      });
    };
    validateInput();
  }, [contactListName, optionSelected, contacts]);

  const selectOutreachContactsCallback = async () => {
    const titles: string[] = [];
    const viewContactList: ContactInterface[] = [];
    const updatedCallSession = callSession;

    const selectedItem = optionSelected.find((option) => {
      return option.select;
    });

    if (selectedItem) {
      titles.push(selectedItem.title);
      let gotContacts: ContactInterface[] = [];
      gotContacts = await createOutreachList(selectedItem);
      updateLoadingStatus({ ...loadingStatus, contacts: false });
      const previewContacts = gotContacts.slice(0, 3);
      previewContacts.forEach((i) => {
        viewContactList.push(i);
      });
      const contactList = {
        id: selectedItem.id,
        contactListId: previewContacts[0].contactListId,
        completed: false,
      };
      updatedCallSession.contactList = [contactList];
      updatedCallSession.contactListName = titles as [string];
      updatedCallSession.totalContacts = gotContacts.length;
      updatedCallSession.previewContacts = viewContactList as [ContactInterface];

      // checkAndRedirectCallSession(callSession, history);
      if (!callSession.contactList) {
        navigate('/contacts?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.voiceDropsIds) {
        navigate('/voice?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.speech) {
        navigate('/script?setup=1', {
          state: { callSession: callSession },
        });
      } else {
        navigate('/home?setup=1', {
          state: { callSession: callSession },
        });
      }

      toast({
        variant: 'default',
        title: 'Selected',
        description: 'Contact list selected.',
      });
    }
  };

  const selectSalesforceContactsCallback = async () => {
    const titles: string[] = [];
    const viewContactList: ContactInterface[] = [];
    const updatedCallSession = callSession;

    const selectedItem = optionSelected.find((option) => {
      return option.select;
    });

    if (selectedItem) {
      titles.push(selectedItem.title);
      let hubspotContacts: ContactInterface[] = [];
      hubspotContacts = await createSalesforceList(selectedItem);
      updateLoadingStatus({ ...loadingStatus, contacts: false });
      const previewContacts = hubspotContacts.slice(0, 3);
      previewContacts.forEach((i) => {
        viewContactList.push(i);
      });
      const contactList = {
        id: selectedItem.id,
        contactListId: previewContacts[0].contactListId,
        completed: false,
      };
      updatedCallSession.contactList = [contactList];
      updatedCallSession.contactListName = titles as [string];
      updatedCallSession.totalContacts = hubspotContacts.length;
      updatedCallSession.previewContacts = viewContactList as [ContactInterface];

      // checkAndRedirectCallSession(callSession, history);
      if (!callSession.contactList) {
        navigate('/contacts?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.voiceDropsIds) {
        navigate('/voice?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.speech) {
        navigate('/script?setup=1', {
          state: { callSession: callSession },
        });
      } else {
        navigate('/home?setup=1', {
          state: { callSession: callSession },
        });
      }

      toast({
        variant: 'default',
        title: 'Selected',
        description: 'Contact list selected.',
      });
    }
  };

  const selectHubspotContactsCallback = async (custom = false) => {
    const titles: string[] = [];
    const viewContactList: ContactInterface[] = [];
    const updatedCallSession = callSession;

    const selectedItem = optionSelected.find((option) => {
      return option.select;
    });

    if (selectedItem) {
      titles.push(selectedItem.title);
      let hubspotContacts: ContactInterface[] = [];
      hubspotContacts = await createHubspotList(selectedItem, custom);
      updateLoadingStatus({ ...loadingStatus, contacts: false });
      const previewContacts = hubspotContacts.slice(0, 3);
      previewContacts.forEach((i) => {
        viewContactList.push(i);
      });
      const contactList = {
        id: selectedItem.id,
        contactListId: previewContacts[0].contactListId,
        completed: false,
      };
      updatedCallSession.contactList = [contactList];
      updatedCallSession.contactListName = titles as [string];
      updatedCallSession.totalContacts = hubspotContacts.length;
      updatedCallSession.previewContacts = viewContactList as [ContactInterface];

      // checkAndRedirectCallSession(callSession, history);
      if (!callSession.contactList) {
        navigate('/contacts?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.voiceDropsIds) {
        navigate('/voice?setup=1', {
          state: { callSession: callSession },
        });
      } else if (!callSession.speech) {
        navigate('/script?setup=1', {
          state: { callSession: callSession },
        });
      } else {
        navigate('/home?setup=1', {
          state: { callSession: callSession },
        });
      }

      toast({
        variant: 'default',
        title: 'Selected',
        description: 'Contact list selected.',
      });
    }
  };

  const selectContactsCallback = () => {
    const found = optionSelected.some((el) => {
      if (el !== undefined) {
        if (el.id === 'newItem' && el.select === true) {
          return el;
        }
      }
    });

    const aux: ContactList[] = [];
    const titles: string[] = [];
    let totalContacts = 0;
    const viewContactList: ContactInterface[] = [];

    if (found) {
      uploadFiles(contactListName);
    } else {
      optionSelected.map(async (item) => {
        if (item !== undefined) {
          if (item.id !== 'newItem' && item.select === true) {
            aux.push(item);
            titles.push(item.title);
            let gotContacts: ContactInterface[] = [];
            gotContacts = await getAllContacts(item);
            updateLoadingStatus({ ...loadingStatus, contacts: false });
            totalContacts += gotContacts.length;
            const previewContacts = gotContacts.slice(0, 3);
            previewContacts.forEach((i) => {
              viewContactList.push(i);
            });
            const callSession1 = callSession;
            callSession1.contactList = aux as [ContactList];
            callSession1.contactList.forEach((value) => {
              value.contactListId = gotContacts[0].contactListId;
              value.completed = false;
            });
            callSession1.contactListName = titles as [string];
            callSession1.totalContacts = totalContacts;
            callSession1.previewContacts = viewContactList as [ContactInterface];

            // checkAndRedirectCallSession(callSession, history);

            if (!callSession.contactList) {
              navigate('/contacts?setup=1', {
                state: { callSession: callSession },
              });
            } else if (!callSession.voiceDropsIds) {
              navigate('/voice?setup=1', {
                state: { callSession: callSession },
              });
            } else if (!callSession.speech) {
              navigate('/script?setup=1', {
                state: { callSession: callSession },
              });
            } else {
              navigate('/home?setup=1', {
                state: { callSession: callSession },
              });
            }

            toast({
              variant: 'default',
              title: 'Selected',
              description: 'Contact list selected.',
            });
          }
        }
      });
    }
  };

  const getAllContacts = async (arr) => {
    try {
      updateLoadingStatus((prevState) => ({
        ...prevState,
        contacts: true,
      }));
      const contactsUrl = `${routes.get.contacts.contactsNest}/${arr.id}`;
      const contactsResponse = await axios.get<ContactInterface[]>(contactsUrl);
      return contactsResponse.data;
    } catch (error) {
      handleEmptyList('There are no contacts for selected contact list');
      throw error;
    }
  };

  const createOutreachList = async (selectedItem) => {
    try {
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const contactsUrl = `${routes.post.contact.contactsNest}/outreach`;

      const data = {
        organizationId: userSession.organizationId,
        title: selectedItem.title,
        outreachSequenceId: selectedItem.sequenceId,
        outreachSequenceStep: Number(selectedItem.id),
        nonce: selectedItem.tendrilId,
      };

      const contactsResponse = await axios.post<ContactInterface[]>(contactsUrl, data);

      return contactsResponse.data;
    } catch (error) {
      handleEmptyList('There are no contacts for selected contact list');
      throw error;
    }
  };

  const createSalesforceList = async (selectedItem) => {
    try {
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const contactsUrl = `${routes.post.contact.contactsNest}/salesforce`;

      const data = {
        organizationId: userSession.organizationId,
        title: selectedItem.title,
        nonce: selectedItem.tendrilId,
        salesforceListId: selectedItem.id,
        userId: userSession.userId,
      };

      const contactsResponse = await axios.post<ContactInterface[]>(contactsUrl, data);

      return contactsResponse.data;
    } catch (error) {
      handleEmptyList('There are no contacts for selected contact list');
      throw error;
    }
  };

  const createHubspotList = async (selectedItem, custom) => {
    try {
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const contactsUrl = custom
        ? `${routes.post.contact.contactsNest}/hubspotCustom`
        : `${routes.post.contact.contactsNest}/hubspot`;

      const data = {
        organizationId: userSession.organizationId,
        title: selectedItem.title,
        listId: Number(selectedItem.id),
        nonce: selectedItem.tendrilId,
      };

      const contactsResponse = await axios.post<ContactInterface[]>(contactsUrl, data);

      return contactsResponse.data;
    } catch (error) {
      handleEmptyList('There are no contacts for selected contact list');
      throw error;
    }
  };

  const getAllOutreachContacts = async (
    { id, tendrilId, sequenceId }: SelectedItem,
    isRefresh = false,
  ): Promise<OutreachProspectDto[]> => {
    try {
      setOutreachDisabledButton(true);
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const nonce = tendrilId;
      const sequenceStepId = id;
      const params = isRefresh ? `?update=${isRefresh}` : '';
      const contactsUrl = `${routes.get.outreach.getProspects}/${nonce}/${sequenceId}/${sequenceStepId}${params}`;
      const contactsResponse = await axios.get<OutreachProspectsResponse>(contactsUrl);

      setOutreachDisabledButton(false);
      updateTimeAgoDate(contactsResponse.data.createdAt);
      updateLoadingStatus({ ...loadingStatus, contacts: false });
      return contactsResponse.data.prospects;
    } catch (error) {
      console.log(error);
      handleEmptyList('There are no contacts for selected sequence step');
      throw error;
    }
  };

  const prepareHubspotContactsForList = (contacts: HubspotContact[]) => {
    return contacts.map((contact) => {
      const { vid, properties, notes } = contact;
      const contactListId = contact['portal-id'] ?? '';
      const name = `${properties.firstname?.value || ''} ${properties.lastname?.value || ''}`;
      const phone =
        properties.mobilephone?.value && properties.mobilephone.value !== ''
          ? properties.mobilephone.value
          : properties.phone?.value
            ? properties.phone.value
            : '';
      return {
        accountName: properties.company?.value || '',
        contactListId,
        email: properties.email?.value || '',
        id: vid,
        jobTitle: properties.jobtitle?.value || '',
        name,
        phone: phone,
        crmId: '',
        notes: notes ? notes.join('\n').replace(/(<([^>]+)>)/gi, '') : '',
        notesAgent: '',
        notesSDR: '',
        errorMessages: [],
      };
    });
  };

  const prepareSalesforceContactsForList = (contacts: SalesforceContact[]) => {
    return contacts.map((contact) => {
      const contactListId = contact['salesforceId'] ?? '';
      const name = `${contact.firstname || ''} ${contact.lastname || ''}`;
      return {
        accountName: contact.company || '',
        contactListId,
        email: contact.email || '',
        id: '',
        jobTitle: contact.title || '',
        name,
        phone: contact.phone,
        crmId: '',
        notes: '',
        notesAgent: '',
        notesSDR: '',
        errorMessages: [],
      };
    });
  };

  const getAllHubspotContacts = async ({ id, tendrilId }, custom = false) => {
    setHubspotDisabledButton(true);
    try {
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const { contacts, error } = await getHubspotContactsAsync(tendrilId, id, custom);

      if (contacts && contacts.length > 0) {
        let contactsResponse: ContactInterface[] = [];
        contactsResponse = prepareHubspotContactsForList(contacts);
        setHubspotDisabledButton(false);
        return contactsResponse;
      } else {
        handleEmptyList('There are no contacts for selected list');
        throw error;
      }
    } catch (error) {
      console.log(error);
      handleEmptyList('There are no contacts for selected list');
      throw error;
    }
  };

  const handleSearch = (searchText: string) => {
    setSearch(searchText);
  };

  const getAllSalesforceContacts = async ({ id, tendrilId }) => {
    setsalesforceDisabledButton(true);
    try {
      updateLoadingStatus({ ...loadingStatus, contacts: true });
      const { contacts, error, reportMetadata, dataCells } = await getSalesforceContactsAsync(
        userSession.organizationId,
        userSession.userId,
        tendrilId,
        id,
      );

      setJsonSalesforce({
        reportMetadata,
        dataCells,
      });

      if (contacts && contacts.length > 0) {
        let contactsResponse: ContactInterface[] = [];
        contactsResponse = prepareSalesforceContactsForList(contacts);
        setsalesforceDisabledButton(false);
        return contactsResponse;
      } else {
        let contactsResponse: ContactInterface[] = [];
        contactsResponse = [];
        handleEmptyList('There are no contacts for selected list');
        return contactsResponse;
      }
    } catch (error) {
      handleEmptyList('There are no contacts for selected list');
      throw error;
    }
  };

  const handleEmptyList = (label: string, showToast?: boolean) => {
    updateLoadingStatus({ ...loadingStatus, contacts: false });
    setLabel(label);
    setVisibleTable(false);
    setVisibleNewCSV(false);
    if (showToast === undefined) {
      toast({
        variant: 'default',
        title: 'Warning',
        description: label,
      });
    }
  };

  const handleNoAccounts = () => {
    return (
      <>
        <StyledSpan>There are no accounts linked to this profile.</StyledSpan>
        <StyledSpan>To link an account go to settings.</StyledSpan>
        <UIButton onClick={goToSettings}>Settings</UIButton>
      </>
    );
  };

  const goToSettings = () => {
    navigate('/settings');
  };

  const uploadFiles = async (contactListName, isFilteredContacts = false) => {
    try {
      let contactListPayload = {
        organizationId: orgId,
        title: contactListName,
        type: 'CSV',
        nonce: 'CSV',
      };

      const contactListResponse = await axios.post(routes.post.contact.contactsListNest, contactListPayload);

      if (contactListResponse.status === 200 || contactListResponse.status === 201) {
        toast({
          variant: 'default',
          title: 'Success',
          description: 'Your contact list was correctly created.',
        });
        const url = `${routes.post.contact.contactsNest}/${contactListResponse.data.id}`;

        let flagResponse: boolean = false;

        if (contactsFilter && isFilteredContacts) {
          let contactsWithOutId = contacts.map((contact) => {
            const { id, ...contactWithOutId } = contact;
            contactWithOutId.contactListId = contactListResponse.data.id;
            return contactWithOutId;
          });

          while (contactsWithOutId.length > 0) {
            const chunk = contactsWithOutId.splice(0, 50);

            const chunkResponse = await axios.post(url, chunk, {
              params: {
                orgId: contactListResponse.data.organizationId,
              },
            });

            flagResponse = chunkResponse.status === 200 || chunkResponse.status === 201 ? true : false;
          }
        } else {
          const blob = new Blob(['\ufeff', newFile]);

          const formData = new FormData();

          formData.append('contactListId', contactListResponse.data.id);

          formData.append('file', blob);

          let response = await axios.post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params: {
              orgId: contactListResponse.data.organizationId,
            },
          });
          flagResponse = response.status === 200 || response.status === 201 ? true : false;
        }

        if (flagResponse) {
          toast({
            variant: 'default',
            title: 'Success',
            description: `${contacts.length} new contacts were added.`,
          });

          const contactListFiltered = contactsList.filter((item) => item.id !== 'newItem');

          setContactsList([contactListResponse.data, ...contactListFiltered]);
        }
      }
    } catch (error) {
      logger.error('Something went wrong while posting contacts to contact list: '.concat(JSON.stringify(error)), {
        componentName: Contacts.name,
      });

      toast({
        variant: 'destructive',
        title: 'Failed',
        description: 'Could not add Contacts to the new List',
      });
    }
  };

  const handleDeleteContactList = async (element) => {
    setOptionSelected([]);
    try {
      const { id } = element;

      if (id) {
        const deleteContactListUrl = `${routes.delete.contacts.deleteContactListNest}/${id}`;
        const deleteContactListReq = await axios.delete(deleteContactListUrl);

        if (deleteContactListReq.status === 200) {
          toast({ variant: 'default', title: 'Success', description: 'Your Contact List was deleted.' });
          const contactListUpdate = contactsList.filter((item) => {
            if (item.id !== element.id && item.id !== 'newItem') {
              return item;
            }
          });
          setContactsList(contactListUpdate);
        }
      }
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Failed',
        description: 'Could not delete Contacts List',
      });
    }
  };

  const handleDeleteAContact = async (elem) => {
    const { id } = elem;
    if (id?.length < 24) {
      setContacts(validateContacts(sortAndFilterContacts(contacts.filter((item) => Number(item.id) !== Number(id)))));
      handleOnDrop(contacts.filter((item) => Number(item.id) !== Number(id)));
    } else {
      if (!id) return;
      const { success, error } = await deleteContactAsync(id);
      if (success) {
        toast({
          variant: 'default',
          title: 'Success',
          description: 'Contact deleted.',
        });
        const contactsUpdate = contacts.filter((item) => item.id !== id);
        setContacts(validateContacts(sortAndFilterContacts(contactsUpdate)));
        return;
      }
      error &&
        toast({
          variant: 'destructive',
          title: 'Failed',
          description: 'Could not delete Contact',
        });
    }
  };

  const handleSelectAnOption = (data: []) => {
    if (data.length && data.length < 0) setVisibleTable(true);
    setOptionSelected(data);
    setSelectedList(data.id);
    setOutreachDisabledButton(true);
    setHubspotDisabledButton(true);
    setsalesforceDisabledButton(true);
  };

  const addNewListAndUsers = async () => {
    const selectedItem = optionSelected.find((elem) => elem.select === true);

    const isFilteredContacts = selectedItem.type === 'filteredContacts';

    setNewFile('');

    setContactListName('');

    await uploadFiles(contactListName, isFilteredContacts);
  };

  const prepareSequenceStepsForList = (sequences: SequenceStep[]) => {
    return sequences.map((sequence) => {
      const { id, attributes, tendrilId, sequenceId } = sequence;
      return {
        id: id.toString(),
        title: sequence.sequenceName ? `${sequence.sequenceName} - ${attributes.displayName}` : attributes.displayName,
        tendrilId,
        sequenceId,
        type: 'OUTREACH',
      };
    });
  };

  const prepareHubspotListsForList = (sequences: HubspotList[], custom = false) => {
    return sequences.map((sequence) => {
      const { listId, name, nonce } = sequence;
      return {
        id: listId,
        title: name,
        tendrilId: nonce,
        type: custom ? 'CUSTOM_HUBSPOT' : 'HUBSPOT',
      };
    });
  };

  const prepareSalesforceListsForList = (list: SalesforceList[]) => {
    return list.map((sequence) => {
      const { id, name, nonce, tendrilUserName } = sequence;
      return {
        id: id,
        title: name,
        tendrilId: nonce,
        userId: userSession.userId,
        orgId: userSession.organizationId,
        type: 'SALESFORCE',
        tendrilUserName: tendrilUserName,
      };
    });
  };

  const handleChangeInput = (e) => {
    setContactListName(e.target.value);
  };

  const handleOnDrop = (data) => {
    const allData = data;
    const getDataFile = (data) => {
      if (data.length > 0) {
        const filterData = data.map((element) => {
          if (element?.name && element?.phone) {
            return {
              name: element?.name,
              phone: element?.phone,
              jobTitle: element?.jobTitle,
              email: element?.email,
              accountName: element?.accountName,
              notes: element?.notes,
              notesAgent: element?.notesAgent,
              notesSDR: '',
              crmId: element?.crmId,
            };
          } else {
            return '';
          }
        });

        const contactsWithoutError = filterData.filter((item) => item.phone !== '#ERROR!');

        const validationFilterData = filterData.find((item) => item !== '');

        if (validationFilterData !== undefined) {
          const dataFile = jsonToCSV(contactsWithoutError, {
            delimiter: ',',
            header: true,
            skipEmptyLines: true,
          });
          setNewFile(dataFile);
          const totalContactsRemoved = allData.length - contactsWithoutError.length;

          if (totalContactsRemoved > 0) {
            toast({
              variant: 'default',
              title: 'Removed contacts',
              description: `${totalContactsRemoved} contacts were removed, due to an incorrect or invalid phone number.`,
            });
          }
        }
      } else {
        setVisibleTable(false);
        setVisibleNewCSV(true);
      }
    };

    if (data[0]?.name) {
      const contactsWithoutError = data.filter((item) => {
        if (item.phone !== '#ERROR!') {
          return item;
        }
      });
      getDataFile(contactsWithoutError);
      const dataToShow = contactsWithoutError.map((item, index) => {
        if (
          item.name !== undefined ||
          item.phone !== undefined ||
          item.jobTitle !== undefined ||
          item.accountName !== undefined
        ) {
          if (item.name === '' || item.phone === '') {
            return {
              ...item,
              id: index,
              error: true,
            };
          } else {
            return {
              ...item,
              id: index,
              error: false,
            };
          }
        } else {
          return undefined;
        }
      });

      if (dataToShow[0] === undefined) {
        setVisibleNewCSV(true);

        toast({
          variant: 'destructive',
          title: 'Failed',
          description: "CSV doesn't match the current template.",
        });

        setDisabled(false);
      } else {
        setContacts(validateContacts(sortAndFilterContacts(dataToShow)));
        setVisibleNewCSV(false);
        setVisibleTable(true);
      }
    } else {
      getDataFile(data);
    }
  };

  const showTrashIcon = () => {
    const elem = optionSelected.find((elem) => elem.select === true);
    return elem && elem.id !== 'newItem';
  };

  const handleOnError = () => {
    toast({
      variant: 'destructive',
      title: 'Failed',
      description: 'Something went wrong, try again later.',
    });
  };

  function sortAndFilterContacts(contacts: CSVContact[]): CSVContact[] {
    if (contacts.length > 0 || !!contacts) {
      // First we check contacts has more than 0 elements or if it is defined (truthy assertion).
      return contacts.sort((a, b) => b.errorMessages?.length - a.errorMessages?.length);
    }
    return contacts;
  }

  const handleOnRemoveFile = () => {
    toast({
      variant: 'default',
      title: 'Sucess',
      description: 'CSV file deleted.',
    });

    setNewFile('');
  };

  const initialTab = 'csvTab';
  const [currentTab, setCurrentTab] = useState(initialTab);

  const contactTabs: Tab[] = [
    {
      id: 'csvTab',
      header: 'CSV Contacts',
      content: (index) => (
        <>
          <SearchBar
            key={index}
            placeholder="Search by title..."
            onSearchResult={(searchResult) => {
              if (searchResult?.success && !!searchResult.data) {
                setContactsList(searchResult.data as ContactsListI[]);
              }
            }}
            fields={['title']}
            urlEndpoint={`${routes.get.contacts.contactListNest}?organizationId=${userSession.organizationId}&`}
          />
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={contactsList}
            deleteItem={handleDeleteContactList}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            newItemTitle="+ New List"
          />
          {showButton && (
            <UIButton
              data-qa-id="contacts-btn"
              disabled={visibleNewCSV}
              onClick={isSession ? selectContactsCallback : addNewListAndUsers}
            >
              {btnText}
            </UIButton>
          )}
        </>
      ),
      callback() {
        setCurrentTab('csvTab');
        setVisibleNewCSV(true);
        setLabel('Select a contact list to show');
      },
    },
  ];

  const [outreachDisabledButton, setOutreachDisabledButton] = useState<boolean>(true);

  if (outreach) {
    contactTabs.push({
      id: 'outreachTab',
      header: 'Outreach',
      content: (_) => (
        <>
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={outreachSequenceSteps}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            setCurrentSelection={(current) => setCurrentSelectedElement(current)}
          />
          {isSession && (
            <UIButton disabled={outreachDisabledButton} onClick={selectOutreachContactsCallback}>
              Upload
            </UIButton>
          )}
        </>
      ),
      async callback() {
        setVisibleTable(false);
        setVisibleNewCSV(false);
        setLabel('Select a sequence to show');
        updateLoadingStatus({ ...loadingStatus, sequences: true });
        const { accounts, error: accountsError } = await getOutreachAccountsAsync(
          userSession.userId,
          userSession.organizationId,
        );
        if (accounts && accounts.length > 0) {
          const { sequenceSteps, error } = await getSequencesStepsFromOutreachAsync(
            userSession.userId,
            userSession.organizationId,
          );
          if (sequenceSteps) {
            setSequenceSteps(prepareSequenceStepsForList(sequenceSteps));
            setCurrentTab('outreachTab');
          } else if (error) {
            handleEmptyList('There are no sequences for your current accounts.');
            console.log(error);
          }
        } else if (accountsError) {
          setLabel(handleNoAccounts());
          console.log(accountsError);
        }
        updateLoadingStatus({ ...loadingStatus, sequences: false });
      },
    });
  }

  if (contactsFilter && !isSession) {
    contactTabs.push({
      id: 'sessionsTab',
      header: 'Sessions',
      content: (_) => (
        <>
          <SearchBar
            placeholder="Search by list title..."
            onSearchResult={(searchResult) => {
              if (searchResult?.success && !!searchResult.data) {
                formatAndSetData(searchResult.data as ContactListByCallSession[]);
              }
            }}
            fields={['title']}
            urlEndpoint={routes.get.callSession.recycleContactsLists.concat(`/${userSession.userId}/${orgId}`)}
          />
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={titlesSession}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            multipleSelection={true}
          />
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <UIButton
                  data-qa-id="contacts-btn"
                  disabled={contactListName === '' || !visibleTable}
                  onClick={addNewListAndUsers}
                >
                  Save
                </UIButton>
              </TooltipTrigger>
              {contactListName === '' && <TooltipContent> To save this list you must add a List Name.</TooltipContent>}
            </Tooltip>
          </TooltipProvider>
        </>
      ),
      callback() {
        setCurrentTab('sessionsTab');
        setVisibleNewCSV(false);
        setVisibleTable(false);
        setLabel('Select a contact list to show');
      },
    });
  }

  const [hubspotDisabledButton, setHubspotDisabledButton] = useState<boolean>(true);

  if (hubspot) {
    contactTabs.push({
      id: 'hubspotTab',
      header: 'HubSpot',
      content: (_) => (
        <>
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={hubspotSequences}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            setCurrentSelection={(current) => setCurrentSelectedElement(current)}
          />
          {isSession && (
            <UIButton disabled={hubspotDisabledButton} onClick={() => selectHubspotContactsCallback()}>
              Upload
            </UIButton>
          )}
        </>
      ),
      async callback() {
        setVisibleTable(false);
        setVisibleNewCSV(false);
        setHubspotLists([]);
        setLabel('Select a sequence to show');
        updateLoadingStatus({ ...loadingStatus, sequences: true });
        const { accounts, error: accountsError } = await getHubspotAccountsAsync(
          userSession.userId,
          userSession.organizationId,
        );
        if (accounts && accounts.length > 0) {
          const { lists, error } = await getListsFromHubspotAsync(userSession.userId, userSession.organizationId);
          if (lists) {
            setHubspotLists(prepareHubspotListsForList(lists));
            setCurrentTab('hubspotTab');
          } else if (error) {
            handleEmptyList('There are no lists for your current accounts.');
            console.log(error);
          }
        } else if (accountsError) {
          setLabel(handleNoAccounts());
          console.log(accountsError.message);
        }
        updateLoadingStatus({ ...loadingStatus, sequences: false });
      },
    });
  }

  if (hubspotCustom) {
    contactTabs.push({
      id: 'hubspotCustomTab',
      header: 'HubSpot Custom',
      content: (_) => (
        <>
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={hubspotSequences}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            setCurrentSelection={(current) => setCurrentSelectedElement(current)}
          />
          {isSession && (
            <UIButton disabled={hubspotDisabledButton} onClick={() => selectHubspotContactsCallback(true)}>
              Upload
            </UIButton>
          )}
        </>
      ),
      async callback() {
        setVisibleTable(false);
        setVisibleNewCSV(false);
        setHubspotLists([]);
        setLabel('Select a sequence to show');
        updateLoadingStatus({ ...loadingStatus, sequences: true });
        const { accounts, error: accountsError } = await getHubspotAccountsAsync(
          userSession.userId,
          userSession.organizationId,
          true,
        );
        if (accounts && accounts.length > 0) {
          const { lists, error } = await getListsFromHubspotAsync(userSession.userId, userSession.organizationId, true);
          if (lists) {
            setHubspotLists(prepareHubspotListsForList(lists, true));
            setCurrentTab('hubspotCustomTab');
          } else if (error) {
            handleEmptyList('There are no lists for your current accounts.');
            console.log(error);
          }
        } else if (accountsError) {
          setLabel(handleNoAccounts());
          console.log(accountsError.message);
        }
        updateLoadingStatus({ ...loadingStatus, sequences: false });
      },
    });
  }

  const [salesforceDisabledButton, setsalesforceDisabledButton] = useState<boolean>(true);

  if (salesforce) {
    contactTabs.push({
      id: 'salesforceTab',
      header: 'SalesForce',
      content: (index) => (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {showReports && (
              <ButtonOutlined
                icon={faArrowLeft}
                onClick={() => {
                  const salesforceTab = contactTabs.find((tab) => tab.id === 'salesforceTab');
                  setShowReports(false);
                  if (salesforceTab && salesforceTab.callback) {
                    salesforceTab.callback();
                  }
                }}
              />
            )}
            {showReports && <p>Folder: {folderName}</p>}
          </div>
          {!showReports && (
            <SearchBar
              key={index}
              placeholder="Search by folder title..."
              onSearchResult={(searchResult) => {
                if (searchResult?.success && !!searchResult.data) {
                  setListsSalesforce(prepareSalesforceListsForList(searchResult.data));
                }
              }}
              fields={['search']}
              urlEndpoint={`${routes.get.salesforce.getFolders}/${orgId}/${userSession.userId}?${search}`}
            />
          )}
          <GenericList
            radioBtn={isSession}
            height="377px"
            data={salesforcesSequences}
            setVisible={setVisibleNewCSV}
            setOptionSelected={handleSelectAnOption}
            rowIcon={showReports ? null : faUserCircle}
            setCurrentSelection={(current) => setCurrentSelectedElement(current)}
          />
          {isSession && (
            <UIButton disabled={salesforceDisabledButton} onClick={() => selectSalesforceContactsCallback()}>
              Upload
            </UIButton>
          )}
        </>
      ),
      async callback() {
        setVisibleTable(false);
        setVisibleNewCSV(false);
        setListsSalesforce([]);
        setLabel('Select a folder for your reports');
        updateLoadingStatus({ ...loadingStatus, sequences: true });
        const { data: accounts, error: accountsError } = await getSalesforceAccounts(
          userSession.userId,
          userSession.organizationId,
        );
        if (accounts && accounts.length > 0) {
          const { lists, error } = await getFoldersSalesforceAsync(userSession.userId, userSession.organizationId);
          if (lists) {
            setListsSalesforce(prepareSalesforceListsForList(lists));
            setCurrentTab('salesforceTab');
          } else if (error) {
            handleEmptyList('There are no lists for your current accounts.');
            console.log(error);
          }
        } else if (accountsError) {
          setLabel(handleNoAccounts());
          console.log(accountsError.message);
        }
        updateLoadingStatus({ ...loadingStatus, sequences: false });
      },
    });
  }

  const handleRefresh = async () => {
    if (currentSelectedElement === undefined) {
      toast({
        variant: 'default',
        title: 'Sequence step not selected',
        description: 'Please select a sequence step',
      });
      return;
    }

    switch (currentTab) {
      case 'outreachTab':
        const outreachContacts = await getAllOutreachContacts(currentSelectedElement, true);
        updateContactsViewStates(outreachContacts);
        break;
    }
  };

  const updateContactsViewStates = (fetchedContacts: Array<CSVContact>): void => {
    if ((!fetchedContacts || fetchedContacts.length === 0) && currentTab != 'salesforceTab') {
      handleEmptyList('There are no contacts for selected list');
    }
    if ((!fetchedContacts || fetchedContacts.length === 0) && currentTab != 'salesforceTab') {
      handleEmptyList('No list selected yet', false);
    }

    setContacts(validateContacts(sortAndFilterContacts(fetchedContacts) ?? []));
    setVisibleNewCSV(false);
    setVisibleTable(true);
    setShowButton(isSession);
    updateLoadingStatus({ ...loadingStatus, contacts: false });
  };

  useEffect(() => {
    switch (currentTab) {
      case 'outreachTab':
        setShowRefreshButton(true);
        break;
      default:
        setShowRefreshButton(false);
        break;
    }
  }, [currentTab]);

  return (
    <Layout
      sidebar
      handleLogout={handleRoutesLogout}
      user={userSession.userName}
      intervals={intervals}
      setIntervals={setIntervals}
    >
      <div style={{ marginRight: '4rem' }}>
        <UITabbedContainer
          title=""
          maxWidth="530px"
          tabs={contactTabs}
          loading={loadingStatus.sequences}
          loadingMessage={'Loading content...'}
          isSettings={false}
        />
      </div>
      <UICard
        title={`${visibleNewCSV ? 'Upload a new CSV' : 'Contacts from selected List'}`}
        showTitle={false}
        width={`${visibleNewCSV ? '375px' : '720px'}`}
        minHeight="460px"
      >
        {visibleTable && (
          <motion.div {...animations.fadeInFromTop}>
            <div className="flex-col items-end space-y-0">
              <div className="flex min-h-full gap-0 justify-between place-items-center mb-0">
                <div className="relative flex items-center">
                  {contactsFilter && currentTab === 'sessionsTab' && (
                    <ContactsFilter
                      selectedSession={sessionIds}
                      onChangeFilters={fetchContactsBySdrId}
                      updateContactsViewStates={updateContactsViewStates}
                      className="absolute right-0 mt-4"
                    />
                  )}
                </div>
                <div className="flex gap-0 place-items-center">
                  {showRefreshButton === true && timeAgo && (
                    <>
                      <p>{timeAgo}</p>
                      <ButtonOutlined
                        icon={faArrowRotateRight}
                        onClick={handleRefresh}
                        loading={loadingStatus.contacts}
                      />
                    </>
                  )}
                </div>

                {showPopUpSalesforce && (
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '50%',
                        maxWidth: '80%',
                        textAlign: 'center',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h3>Salesforce Metadata:</h3>
                      <div
                        style={{
                          maxHeight: '500px',
                          overflowY: 'auto',
                          textAlign: 'left',
                          whiteSpace: 'pre-wrap',
                          wordWrap: 'break-word',
                          margin: '0px',
                          padding: '0px',
                        }}
                      >
                        <pre style={{ fontSize: '12px' }}>{JSON.stringify(salesforceJson, null, 2)}</pre>
                      </div>

                      <button
                        onClick={() => setShowPopUpSalesforce(false)}
                        style={{
                          backgroundColor: '#007bff',
                          color: 'white',
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          marginTop: '10px',
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                )}
                {currentTab === 'csvTab' && (
                  <div style={{ padding: 0, margin: 0, width: '56%' }}>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <ButtonOutlined
                            data-qa-id="downloadOriginalCSV"
                            icon={faDownload}
                            onClick={() => rebuildContactsCSV(contacts[0].contactListId, ContactsRepository())}
                          />
                        </TooltipTrigger>
                        <TooltipContent>Download list</TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                )}
                {currentTab === 'salesforceTab' && (
                  <div style={{ padding: 0, margin: 0, width: '50%' }}>
                    <ButtonOutlined icon={faBug} onClick={() => setShowPopUpSalesforce(true)} />
                  </div>
                )}
                <p style={{ marginRight: '20px' }}>Contacts: {contacts.length || 0}</p>
                <p>
                  Contacts with warnings:{' '}
                  {
                    contacts.filter(
                      (contact) => Array.isArray(contact.errorMessages) && contact.errorMessages.length > 0,
                    ).length
                  }
                </p>
              </div>
              {contactsFilter && currentTab === 'sessionsTab' && (
                <Input
                  data-qa-id={`input-contact-list-sessions-name`}
                  type="text"
                  placeholder="List name"
                  onChange={handleChangeInput}
                  className="text-base placeholder-gray-300 sm:gray-300 md:placeholder-gray-300 lg:placeholder-gray-300 xl:placeholder-gray-300"
                />
              )}
            </div>
          </motion.div>
        )}

        {loadingStatus.contacts ? (
          <div className="flex w-full h-full justify-center items-center">
            <UILoader size="[80em]" message={'Loading contacts, please wait...'} />
          </div>
        ) : (
          <>
            {visibleNewCSV && (
              <NewCSV
                width="100%"
                height="auto"
                handleOnDrop={handleOnDrop}
                handleOnError={handleOnError}
                handleOnRemoveFile={handleOnRemoveFile}
                setContactListName={setContactListName}
              />
            )}
            {visibleTable && (
              <UITable
                maxHeight="377px"
                headers={currentTab === 'csvTab' ? [...tableHeaders, { text: '', width: '0.50' }] : tableHeaders}
                tableBodies={
                  currentTab === 'csvTab'
                    ? !showTrashIcon()
                      ? tableBody
                      : [...tableBody, { icon: 'trash' }]
                    : tableBody
                }
                data={sortAndFilterContacts(contacts)}
                selectionHandler={handleDeleteAContact}
                setSelectedRow={setSelectedRow}
                visible={false}
              />
            )}
            {!visibleTable && !visibleNewCSV && <TextContainer>{label}</TextContainer>}
          </>
        )}
      </UICard>
    </Layout>
  );
};

export default Contacts;
